module.exports = __webpack_public_path__ + "static/media/store.b45357d3.svg";